<template>
<div>
  <p class="has-text-weight-bold">
    {{ `${actualIndex}. ${title}` }}
  </p>
  <!-- <p v-if="unresolvedFindingsCount > 0">
    {{ unresolvedFindingsCount }} unresolved finding<span v-if="unresolvedFindingsCount !== 1">s</span>.
  </p>   -->
</div>
</template>
<script>
export default {
  
  props: {
    checkpointIndex: {
      type: Number
    },
    title: {
      type: String
    },
    unresolvedFindingsCount: {
      type: Number,
      default: 0
    }
  },

  computed: {
    actualIndex() {
      return this.checkpointIndex + 1
    }
  }

}
</script>